// Definição única dos estados de uma marcação (agendamento).
//
// Centraliza label, cor e descrição de cada estado, para não haver
// duplicação (nem cores inconsistentes) espalhada pelos componentes.
// A cor é a mesma usada na Agenda (verde/castanho/laranja/vermelho).

export const ESTADOS = {
  confirmado: { label: 'Confirmado', cor: '#16A34A', descricao: 'Marcação agendada, ainda por realizar.' },
  concluido:  { label: 'Concluído',  cor: '#8B4A2F', descricao: 'Serviço realizado.' },
  falta:      { label: 'Falta',      cor: '#EA580C', descricao: 'Cliente não compareceu.' },
  cancelado:  { label: 'Cancelado',  cor: '#DC2626', descricao: 'Marcação cancelada.' },
}

export const ORDEM_ESTADOS = ['confirmado', 'concluido', 'falta', 'cancelado']

// Configuração de um estado, com fallback seguro para valores desconhecidos.
export const estadoCfg = (estado) =>
  ESTADOS[estado] || { label: estado, cor: '#6B7280', descricao: '' }
